<section class="grid-container">

  <div class="tabs-container" [hidden]="displayDetailView">
    <tabs (tabClicked)="onTabClicked($event)">
      <tab title="Summary">
        <fa-list (companyClicked)="showDetail($event)" [gridAriaLabel]="widgetTitle + ' - Summary'"></fa-list>
      </tab>
      <!-- <tab title="Pending">
      <fa-pending [isInternal]="true" [complianceData]="complianceData" [gridAriaLabel]="widgetTitle + ' - Pending'"></fa-pending>
    </tab> -->
    <tab title="First Review">
      <fa-pending-internal [isInternal]="true" [complianceData]="complianceData"
      [reviewLevel]="'first'" [gridAriaLabel]="widgetTitle + ' - First Review'"></fa-pending-internal>
    </tab>
    <tab title="Final Review">
      <fa-pending-internal [isInternal]="true" [complianceData]="complianceData"
      [reviewLevel]="'final'" [gridAriaLabel]="widgetTitle + ' - Final Review'"></fa-pending-internal>
    </tab>
    <tab title="Returned">
      <fa-returned-flow [isInternal]="true" [complianceData]="complianceData" [gridAriaLabel]="widgetTitle + ' - Returned'"></fa-returned-flow>
    </tab>
    <tab title="FA Expiring Soon">
      <internal-upcoming-bond-expiration-widget (companyClicked)="showDetail($event)"
      [complianceData]="complianceData" [gridAriaLabel]="widgetTitle + ' - FA Expiring Soon'"></internal-upcoming-bond-expiration-widget>
    </tab>
    <tab title="Insurance Expiring Soon">
      <internal-upcoming-insurance-expiration-widget (companyClicked)="showDetail($event)"
      [complianceData]="complianceData" [gridAriaLabel]="widgetTitle + ' - Insurance Expiring Soon'"></internal-upcoming-insurance-expiration-widget>
    </tab>
    <tab title="Awaiting FA Return">
      <fa-awaiting-return [isInternal]="true" [complianceData]="complianceData" [gridAriaLabel]="widgetTitle + ' - Awaiting FA Return'"></fa-awaiting-return>
    </tab>
    <tab title="Complete">
      <fa-complete [isInternal]="true" [complianceData]="complianceData" [gridAriaLabel]="widgetTitle + ' - Complete'"></fa-complete>
    </tab>
    <tab title="Stratigraphic Well Status">
      <stratigraphic-wells-requiring-bonding
      [data]="allStratigraphic" [gridAriaLabel]="widgetTitle + ' - Stratigraphic Well Status'"></stratigraphic-wells-requiring-bonding>
    </tab>
    <tab title="Stratigraphic Wells - No Bonding">
      <stratigraphic-wells-no-bonding [data]="noBondingStratigraphic" [gridAriaLabel]="widgetTitle + ' - Stratigraphic Wells - No Bonding'"></stratigraphic-wells-no-bonding>
    </tab>
  </tabs>
</div>

@if (displayDetailView) {
  <a (click)="hideDetail()">&lt; &lt; Back to Summary</a>
  <tabs (tabClicked)="onDetailTabClicked()">
    <tab title="Bonding">
      <fa-bonding [externalView]="false" [isRecalculating]="isRecalculating" [isLoading]="false"
        [complianceDetails]="faSummary" (recalculateEvent)="recalculate($event)"
      [orgId]="orgId" [gridAriaLabel]="widgetTitle + ' - Bonding'"></fa-bonding>
    </tab>
    <tab title="Insurance">
      <fa-insurance [externalView]="false" [isRecalculating]="isRecalculating" [isLoading]="false"
        [complianceDetails]="faSummary" (recalculateEvent)="recalculate($event)"
      [orgId]="orgId" [gridAriaLabel]="widgetTitle + ' - Insurance'"></fa-insurance>
    </tab>
    <tab title="Pending">
      <fa-pending [isInternal]="true" [orgId]="orgId" [gridAriaLabel]="widgetTitle + ' - Pending'"></fa-pending>
    </tab>
    <tab title="First">
      <fa-pending-internal [isInternal]="true" [complianceData]="complianceData"
      [reviewLevel]="'first'" [gridAriaLabel]="widgetTitle + ' - First'"></fa-pending-internal>
    </tab>
    <!-- <tab title="Final Review">
    <fa-pending-internal [isInternal]="true" [complianceData]="complianceData" [reviewLevel]="'final'" [gridAriaLabel]="widgetTitle + ' - Final Review'"></fa-pending-internal>
  </tab> -->
</tabs>
}
</section>